<template>
  <div class="newGroupingPage">
    <MapModal
      class="newModelPosition hierarchy2"
      :modalNode="modalNode"
      title="克隆标绘"
      id="scenePlottingClon"
      :close="close"
    >
      <template slot="content">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="settings"
          label-width="80px"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-form-item label="选择场景" prop="newScenesId">
            <el-cascader
              v-model="form.newScenesId"
              :options="grouping"
              :props="{
                label: 'name',
                children: 'scenesData',
                value: 'id',
                emitPath: false,
              }"
            ></el-cascader>
          </el-form-item>
          <el-form-item class="submitBtn btns">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="onSubmit('form')">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </MapModal>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import { cloneSceneBimPlanPainting } from "@/api/api.js";
export default {
  components: {
    MapModal,
  },
  props: {
    oldScenes: {
      type: Object,
    },
    grouping: {
      type: Array,
    },
  },
  data() {
    return {
      modalNode: {
        scenePlottingClon: {
          show: true, // 默认展示
          loading: false, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   x: 55,
          //   y: -650,
          // },
          // width: "450px", // 宽度配置 默认450px
          height: "150px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      rules: {
        newScenesId: [
          { required: true, message: "请选择场景", trigger: "blur" },
        ],
      },
      form: {
        newScenesId: null,
      },
    };
  },
  created() {
    // if (this.groupProps.name) {
    //   this.form.name = this.groupProps.name;
    // }
  },

  mounted() {
    console.log("grouping", this.grouping);
  },
  watch: {
    // "form."(newVal, oldVal) {
    //   console.log("oldScenes", newVal, oldVal);
    // },
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            newScenesId: this.form.newScenesId,
            oldScenesId: this.oldScenes.id,
            projectId: window.sessionStorage.getItem("nowProjectId"),
          };

          cloneSceneBimPlanPainting(params)
            .then((res) => {
              this.loading = false;
              this.close();
              this.$notify({
                title: `新增分组成功！`,
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            })
            .catch((err) => {
              this.loading = false;
              this.$notify({
                title: `新增分组失败！`,
                message: "",
                type: "error",
                duration: 960,
                offset: 320,
              });
            });
        } else {
          this.$notify({
            title: `请选择场景`,
            message: "",
            type: "error",
            duration: 960,
            offset: 320,
          });
          return false;
        }
      });
    },
    close() {
      this.$emit("closeScenePlotting");
    },
  },
};
</script>

<style lang="scss" scoped>
.newGroupingPage {
  /deep/.el-form.settings {
    width: 100%;
    @include hvcenter(column);
    // padding: 8px 0 0 0;
    padding: 8px 0 14px 0;
    .el-form-item {
      width: 100%;
      padding: 0 0 0 7px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 18px;
      .el-form-item__label {
        margin-bottom: 0px;
        font-size: 12px;
        @include font_color("t_color_op1");
        padding: 0;
        flex-grow: 0;
        line-height: 32px;
        padding-right: 10px;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-grow: 1;
        line-height: 32px;
        .el-select {
          @include select_base();
        }
        .el-autocomplete {
          @include select_base();
        }
        .el-input {
          @include input_base();
        }
        .el-textarea {
          @include textarea_base();
        }
        .el-checkbox {
          @include checkbox_base();
        }
      }
      .showInline {
        margin: 10px 6px;
        width: 96px;
        display: inline-block;
        text-align: right;
        @include lheight(26);
        font-size: 11px;
        @include font_color("t_color_op1");
        .el-input-number {
          margin-left: -5px !important;
          @include input_number();
        }
        .el-input-number__increase {
          height: 32px;
          line-height: 32px;
        }
        .el-input__inner {
          width: 100% !important;
        }
      }
      &:first-child {
        padding: 10px 0 0 7px;
      }
      &.description {
        margin-bottom: 12px;
      }

      &.btns {
        margin-bottom: 12px;
        .el-form-item__content {
          width: 166px;
          @include button_primary();
          @include button_default();
        }
      }
    }
  }
}
/deep/.el-button--default {
  border-color: rgba(255, 255, 255, 0.9) !important;
  background-color: rgba(234, 242, 248, 0.3) !important;
  color: rgba(245, 245, 245, 0.6) !important;
}
.submitBtn {
  display: flex;
  flex-direction: inherit !important;
}
</style>
